import { Severity } from '../../../common/enums/Severity';
import { Project } from './valueObjects/Project';

export class PriorityFix {
  constructor(
    private readonly number: number,
    private readonly name: string,
    private readonly description: string,
    private readonly severity: Severity,
    private readonly project: Project | null
  ) {}

  getNumber() {
    return this.number;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getSeverity() {
    return this.severity;
  }

  getProject() {
    return this.project;
  }
}
